<ids-tree #IDSTree id="drill-navigation-tree" label="Drill Around" expand-target="icon"></ids-tree>
